import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Collapse,
  ListItemIcon,
  ListItemButton,
  ListItemText,
  Divider,
} from "@mui/material";
import DifferenceIcon from "@mui/icons-material/Difference";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import SpeakerNotesIcon from "@mui/icons-material/SpeakerNotes";
import { useNavigate } from "react-router-dom";
import { marked } from "marked";
import SummarizeIcon from "@mui/icons-material/Summarize";
import { AppContext } from "../../AppContext";
import FileCopyIcon from "@mui/icons-material/FileCopy";

function Sidebar(props) {
  const navigate = useNavigate();
  const { collapse, setCollapse } = useContext(AppContext);
  const [openFoundationModelsDialog, setShowFoundationModelsDialog] =
    useState(false);
  const [foundationModelsData, setFoundationModelsData] = useState("");

  const handleDialogOpen = () => {
    setShowFoundationModelsDialog(true);
  };

  const handleDialogClose = () => {
    setShowFoundationModelsDialog(false);
  };

  useEffect(() => {
    const readmePath = require("../../assets/foundation_models.md");

    fetch(readmePath)
      .then((response) => {
        return response.text();
      })
      .then((text) => {
        setFoundationModelsData(marked(text));
      });
  }, []);

  return (
    <>
      <div className={`sidebar`}>
        <div
          style={{
            marginTop: "10px",
            height: "calc(100% - 69px)",
            position: "relative",
          }}
        >
          <div className="sidebar-button-divs sidebar-button-dropdown">
            <Button
              sx={{
                width: "98%",
                fontWeight: "bold",
                color: "black",
                marginTop: "5px",
                marginBottom: "5px",
              }}
              onClick={() => {
                setCollapse(!collapse);
              }}
              endIcon={
                collapse ? (
                  <KeyboardArrowUpIcon
                    sx={{
                      position: "absolute",
                      right: "10px",
                      top: "6px",
                    }}
                  />
                ) : (
                  <KeyboardArrowDownIcon
                    sx={{
                      position: "absolute",
                      right: "10px",
                      top: "6px",
                    }}
                  />
                )
              }
            >
              Overview
            </Button>
            <Collapse in={collapse} sx={{ width: "100%" }}>
              <Divider
                sx={{
                  backgroundColor: "#004987",
                  marginLeft: "14px",
                  marginRight: "14px",
                }}
              />
              {/* <MenuList> */}
              <ListItemButton
                sx={{
                  paddingLeft: "30px",
                }}
                onClick={() => {
                  navigate("/overview");
                }}
                selected={window?.location?.href?.includes("overview")}
              >
                <ListItemIcon>
                  <SpeakerNotesIcon
                    color={
                      window?.location?.href?.includes("overview")
                        ? "primary"
                        : "action"
                    }
                  />
                </ListItemIcon>
                <ListItemText primary="Chat/Report" />
              </ListItemButton>
              <Divider
                sx={{
                  backgroundColor: "#004987",
                  marginLeft: "14px",
                  marginRight: "14px",
                }}
              />
              {/* <MenuList> */}
              <ListItemButton
                sx={{
                  paddingLeft: "30px",
                }}
                onClick={() => {
                  navigate("/compare");
                }}
                selected={window?.location?.href?.includes("compare")}
              >
                <ListItemIcon>
                  <DifferenceIcon
                    color={
                      window?.location?.href?.includes("compare")
                        ? "primary"
                        : "action"
                    }
                  />
                </ListItemIcon>
                <ListItemText primary="Compare" />
              </ListItemButton>
              <Divider
                sx={{
                  backgroundColor: "#004987",
                  marginLeft: "14px",
                  marginRight: "14px",
                }}
              />
              <ListItemButton
                sx={{
                  paddingLeft: "30px",
                }}
                onClick={() => {
                  navigate("/cluster");
                }}
                selected={window?.location?.href?.includes("cluster")}
              >
                <ListItemIcon>
                  <DriveFolderUploadIcon
                    color={
                      window?.location?.href?.includes("cluster")
                        ? "primary"
                        : "action"
                    }
                  />
                </ListItemIcon>

                <ListItemText primary="Cluster" />
              </ListItemButton>
              <Divider
                sx={{
                  backgroundColor: "#004987",
                  marginLeft: "14px",
                  marginRight: "14px",
                }}
              />
              <ListItemButton
                sx={{
                  paddingLeft: "30px",
                }}
                onClick={() => {
                  navigate("/summarize");
                }}
                selected={window?.location?.href?.includes("summarize")}
              >
                <ListItemIcon>
                  <SummarizeIcon
                    color={
                      window?.location?.href?.includes("summarize")
                        ? "primary"
                        : "action"
                    }
                  />
                </ListItemIcon>

                <ListItemText primary="Summarize" />
              </ListItemButton>
              <Divider
                sx={{
                  backgroundColor: "#004987",
                  marginLeft: "14px",
                  marginRight: "14px",
                }}
              />
              <ListItemButton
                sx={{
                  paddingLeft: "30px",
                }}
                onClick={() => {
                  navigate("/similarity");
                }}
                selected={window?.location?.href?.includes("similarity")}
              >
                <ListItemIcon>
                  <FileCopyIcon
                    color={
                      window?.location?.href?.includes("similarity")
                        ? "primary"
                        : "action"
                    }
                  />
                </ListItemIcon>

                <ListItemText primary="Find Similar Documents" />
              </ListItemButton>
              {/* </MenuList> */}
            </Collapse>
          </div>

          <div className="sidebar-button-divs">
            <Button
              sx={{
                width: "98%",
                fontWeight: "bold",
                color: "black",
              }}
              onClick={() => {
                navigate("/chat", {
                  state: {
                    selectedTab: "Draft Evidence Report Generator",
                    isUseModel: true,
                  },
                });
              }}
            >
              Use Model
            </Button>
          </div>

          <div
            className="sidebar-button-divs"
            style={{
              position: "absolute",
              bottom: "20px",
              width: "98%",
              margin: "0px",
              left: "3px",
            }}
          >
            <Button
              sx={{
                width: "98%",
                fontWeight: "bold",
                color: "black",
              }}
              onClick={() => handleDialogOpen()}
            >
              Foundation Models
            </Button>
          </div>
        </div>
      </div>

      <Dialog
        open={openFoundationModelsDialog}
        onClose={handleDialogClose}
        fullWidth
        maxWidth="md"
        sx={{ borderRadius: "14px" }}
      >
        <>
          <div style={styles.dialogContentDiv}>
            {/* <Button variant="contained" color="warning" onClick={handleModalClose}>
          &#10005;
        </Button> */}
          </div>
          <DialogContent sx={{ paddingTop: "10px" }}>
            <div
              dangerouslySetInnerHTML={{
                __html: foundationModelsData,
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose}>Close</Button>
          </DialogActions>
        </>
      </Dialog>
    </>
  );
}

export default Sidebar;

const styles = {
  dialogContentDiv: {
    display: "flex",
    justifyContent: "flex-end",
    margin: "20px 20px 0px 0px",
  },
};
